<div class="col-2 inner-nav p-2">
  <div class="list-filter-sec">
    <div class="title">Filter</div>
    <form [formGroup]="historyListSearchForm" (ngSubmit)="filterResults()" class="search-form">
      <div class="form-group">
        <input id="search-keyword" class="form-control form-control-sm" placeholder="Search Keyword" formControlName="keyword">
      </div>
      <div class="form-group">
        <ng-select class="custom-style" id="project-list" [items]="projects" bindLabel="name" bindValue="id" placeholder="Select project(s)" [searchable]="true" [multiple]="true" formControlName="projectIds">
          <ng-template ng-option-tmp let-item="item">
            <div title="{{item.name}}" class="text-truncate">{{item.name}}</div>
          </ng-template>
        </ng-select>
      </div>
      <div class="form-group">
        <ng-select class="custom-style" id="executed-by" [items]="users" bindLabel="displayName" bindValue="id" placeholder="Select executed by" [searchable]="true" [multiple]="false" formControlName="executedBy">
          <ng-option [value]="">Select executed by</ng-option>
        </ng-select>
      </div>
      <div class="form-group">
        <ng-select class="custom-style" id="execution-status" [items]="executionStatusList" placeholder="Select Status" [searchable]="true" [multiple]="false" formControlName="executionStatus">
          <ng-option [value]="">Select Status</ng-option>
        </ng-select>
      </div>

      <div class="form-group">
        <label for="from-date">From</label>
        <input id="from-date" class="form-control form-control-sm" container="body" placeholder="yyyy-mm-dd" ngbDatepicker #fromDateDp="ngbDatepicker" formControlName="fromDate" [maxDate]="maxDate" (click)="fromDateDp.toggle()" (ngModelChange)="setMindate()" autocomplete="off">
      </div>
      <div class="form-group">
        <label for="to-date">To</label>
        <input id="to-date" class="form-control form-control-sm" container="body" placeholder="yyyy-mm-dd" ngbDatepicker #toDateDp="ngbDatepicker" [minDate]="minDate" [disabled]="historyListSearchForm?.value.fromDate === null" [maxDate]="maxDate" formControlName="toDate" (click)="toDateDp.toggle()" autocomplete="off">
      </div>

      <div class="form-row">
        <div class="col-6">
          <a id="clear" (click)="clearSearchFilter()" class="clear-filter">
            <i>Clear filter</i>
          </a>
        </div>
        <div class="col-6 text-right">
          <button id="submit-form" type="submit" class="btn btn-primary btn-sm" name="button">Search</button>
        </div>
      </div>
    </form>
  </div>
</div>